var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pending__lab_test"},[_c('LabTestTable',{attrs:{"labTests":_vm.lab_tests,"data":_vm.data},on:{"update:data":function($event){_vm.data=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }